// portal-to-body.directive.ts
import {
    Directive,
    ElementRef,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    Renderer2
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
    selector: '[portalToBody]',
    standalone: true
})
export class PortalToBodyDirective implements OnInit, OnDestroy {
    @Input() applyPortalToBody: boolean = true;

    private placeholder?: Comment;
    private moved = false;

    constructor(
        private el: ElementRef<HTMLElement>,
        private r: Renderer2,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    ngOnInit(): void {
        if (!this.applyPortalToBody) return; // 🚫 no aplicar si está en false
        if (!isPlatformBrowser(this.platformId)) return;

        const node = this.el.nativeElement;
        const parent = node.parentNode;
        if (!parent) return;

        this.placeholder = document.createComment('portal-to-body');
        this.r.insertBefore(parent, this.placeholder, node);

        this.r.appendChild(document.body, node);
        this.moved = true;
    }

    ngOnDestroy(): void {
        if (!this.moved || !this.placeholder) return;
        const node = this.el.nativeElement;
        const parent = this.placeholder.parentNode;
        if (parent) {
            this.r.insertBefore(parent, node, this.placeholder);
        }
        this.placeholder.remove?.();
    }
}